import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { AggrPlaysByDayResponse } from '@/api/routes/stat/types';

import { fetchAggrPlaysByDay } from './actionCreators';

interface InitialState {
  total_device_count: number,
  play_count: number [],
  airtime: number [],
  prevTotalDeviceCount: number,
  prevAirtime: number [],
  timeBegin: number | null,
  timeEnd: number | null,
  isLoading: boolean,
  error: string,
}

const initialState: InitialState = {
  total_device_count: 0,
  play_count: [],
  airtime: [],
  prevTotalDeviceCount: 0,
  prevAirtime: [],
  timeBegin: null,
  timeEnd: null,
  isLoading: false,
  error: '',
};

export const aggrPlaysByDaySlice = createSlice({
  name: 'aggrPlaysByDay',
  initialState,
  reducers: {
    selectTime: (state, action: PayloadAction<{
      timeBegin: number,
      timeEnd: number,
    }>) => {
      state.timeBegin = action.payload.timeBegin;
      state.timeEnd = action.payload.timeEnd;
    },
  },
  extraReducers: {
    [fetchAggrPlaysByDay.fulfilled.type]: (state, action: PayloadAction<AggrPlaysByDayResponse>) => {
      state.isLoading = false;
      state.error = '';
      state.prevTotalDeviceCount = state.total_device_count;
      state.total_device_count = action.payload.total_device_count;
      state.play_count = action.payload.play_count;
      state.prevAirtime = state.airtime;
      state.airtime = action.payload.airtime;
    },
    [fetchAggrPlaysByDay.pending.type]: (state) => {
      state.isLoading = true;
    },
    [fetchAggrPlaysByDay.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const { selectTime } = aggrPlaysByDaySlice.actions;
export default aggrPlaysByDaySlice.reducer;
